<template>
  <a-modal
    v-bind="attrs"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    :centered="true"
    okText="确认"
    :z-index="1004"
  >
    <template #title>
      <div class="flex-s">
        <span class="fw-7 pr-10">保存到</span>
        <a-select
          v-model:value="dataScope"
          size="small"
          :options="dataScopeList"
          style="min-width: 100px"
          @change="selectChange"
        ></a-select>
      </div>
    </template>
    <a-input-search
      v-model:value="searchValue"
      placeholder="文件夹"
      style="width: 100%"
      class="mt-20"
      @search="onSearch"
      @change="inputChange"
    />
    <div class="mt-10">最近</div>
    <div class="scroll">
      <a-tag
        v-for="item in recentlyData"
        :class="{
          'bg-color': select.includes(item.id)
        }"
        :key="item"
        class="cursor-p mb-4 mt-4"
        @click="selectItem(item)"
      >
        <template #icon>
          <component :is="icons[item.icon]"></component>
        </template>
        {{ item.name }}
      </a-tag>
    </div>
    <div class="scroll mt-10" v-if="isSearch">
      <loadMore
        url="/aigcDam/aigc-folder/getAigcFolderDetailPageList"
        @updateList="updateList"
        :search-data="{
          name: searchValue,
          teamId: dataScope,
          ownerType: !dataScope.length ? '0' : '1',
          moduleType: '1'
        }"
        height="300px"
      >
        <div
          class="mb-2 cursor-p padding-4"
          v-for="i in dataList"
          :key="i.id"
          @click="clickItem(i)"
          :class="{
            'bg-color': i.id === select[0]
          }"
        >
          <div class="flex-s">
            <component :is="icons[i.icon]" class="fs-14 mr-6"></component>
            <div class="show1Row">
              {{ i.name }}
            </div>
          </div>
        </div>
      </loadMore>
    </div>
    <div v-else>
      <div class="mt-10 mb-10 flex-b">
        <div>文件夹（{{ data.length }}）</div>
        <div class="flex cursor-p" @click="add">
          <component class="mr-6" :is="icons['PlusOutlined']" />新建文件夹
        </div>
      </div>
      <div class="scroll mt-10">
        <tree
          v-model:selectList="select"
          @loadData="loadData"
          :data="data"
          :key="time"
          :options="options"
        >
          <template #item="{ item }">
            <component :is="icons[item.icon]" class="fs-14 mr-6"></component>
            <span>{{ item.name }}</span>
          </template>
          <template #optionItem="{ item }">
            {{ item.fileNum }}
          </template>
        </tree>
      </div>
    </div>
  </a-modal>
  <importModal />
</template>

<script setup>
import {
  Modal as AModal,
  InputSearch as AInputSearch,
  Tag as ATag,
  Select as ASelect,
  message
} from 'ant-design-vue'
import { ref, useAttrs, watch } from 'vue'
import { aigcStore } from '@/store/aigcStore'
import tree from '@/components/tree.vue'
import * as icons from '@ant-design/icons-vue'
import { local } from '@/utils/storage'
import { queryTeam } from '@/service/api/team'
import { localCache } from '@/utils/cache'
import {
  queryFolderList,
  saveToKnowledgeBase,
  saveToKnowledgeBaseImg,
  getRecentlyUsedFolderList,
  saveUploadAigcFiles
} from '@/service/api/aiDam'
import loadMore from '@/components/paginationQuery/loadMore.vue'
import eventsBus from '@/utils/eventsBus'
import { getFileExtension } from '@/utils/videoEditingAssistant'
import { getFileName } from '@/utils'
import importModal from '@/views/aiDAM/modal/importModal'

const emits = defineEmits(['asyncSuccess'])

const store = aigcStore()
const attrs = useAttrs()
const confirmLoading = ref(false)
const select = ref([])
const searchValue = ref('')
const dataScope = ref('')
const isSearch = ref(false)
const dataList = ref([])
const data = ref([])
const time = ref('1')
const recentlyData = ref([])
const dataScopeList = ref([])
const options = ref([
  {
    text: '新建文件夹',
    fnClick: (res) => {
      store.openNewFolderModal({
        ...res,
        type: 'add',
        teamId: dataScope.value,
        ownerType: !dataScope.value?.length ? '0' : '1',
        parentId: res.parentId || '0',
        notPermissionList: !dataScope.value?.length
      })
    }
  },
  {
    text: '新建子文件夹',
    fnClick: (res) => {
      store.openNewFolderModal({
        ...res,
        addChild: true,
        type: 'add',
        teamId: dataScope.value,
        ownerType: !dataScope.value?.length ? '0' : '1',
        parentId: res.id,
        notPermissionList: !dataScope.value?.length
      })
    }
  }
])

const loadData = (treeNode, cb) => {
  queryFolderList({ parentId: treeNode.id, teamId: dataScope.value }, treeNode.id).then((res) => {
    console.log(res.data)
    if (res?.data) {
      cb && cb(res.data)
    } else {
      cb && cb([])
    }
  })
}
const clickItem = (i) => {
  select.value[0] = i.id
}
const updateList = (list) => {
  dataList.value = list
}
const onSearch = () => {
  isSearch.value = !!searchValue.value.length
  select.value = []
  time.value = Date.now()
}
const inputChange = () => {
  if (!searchValue.value.length) {
    onSearch()
  }
}
const handleOk = () => {
  if (!select.value[0]?.length) return message.error('请选择文件夹')
  confirmLoading.value = true
  let handle = null
  let obj = {}
  if (store.saveToDatabaseData.moduleType === 'imageGeneration') {
    handle = saveToKnowledgeBaseImg
    obj = {
      chatRecordIds: store.saveToDatabaseData.fileIds || '',
      targetFolderId: select.value[0],
      teamId: dataScope.value,
      ownerType: !dataScope.value?.length ? '0' : '1'
    }
  } else if (store.saveToDatabaseData.moduleType === 'designAgentPoster') {
    handle = saveUploadAigcFiles
    obj = {
      bizType: 'IMAGE',
      type: 'IMAGE',
      ext: getFileExtension(store.saveToDatabaseData.posterUrl),
      name: getFileName(store.saveToDatabaseData.posterUrl),
      imageUrl: store.saveToDatabaseData.posterUrl,
      folderId: select.value[0],
      teamId: dataScope.value,
      ownerType: !dataScope.value?.length ? '0' : '1'
    }
  } else if (store.saveToDatabaseData.moduleType === 'designAgentImage') {
    handle = saveUploadAigcFiles
    obj = {
      bizType: 'IMAGE',
      type: 'IMAGE',
      ext: getFileExtension(store.saveToDatabaseData.imageUrl),
      name: getFileName(store.saveToDatabaseData.imageUrl),
      imageUrl: store.saveToDatabaseData.imageUrl,
      folderId: select.value[0],
      teamId: dataScope.value,
      ownerType: !dataScope.value?.length ? '0' : '1'
    }
  } else {
    handle = saveToKnowledgeBase
    obj = {
      folderIds: store.saveToDatabaseData.folderIds || [],
      fileIds: store.saveToDatabaseData.fileIds || [],
      targetFolderId: select.value[0],
      teamId: dataScope.value,
      ownerType: !dataScope.value?.length ? '0' : '1'
    }
  }
  handle(obj, select.value[0]).then((res) => {
    if (res?.data) {
      message.success('转存成功')
      emits('asyncSuccess', select.value)
    }
    confirmLoading.value = false
  })
}
const selectItem = (item) => {
  select.value[0] = item.id
}
const getFolderList = () => {
  const obj = {
    teamId: dataScope.value,
    ownerType: !dataScope.value?.length ? '0' : '1',
    moduleType: '1'
  }
  queryFolderList({ parentId: '0', ...obj }, '0').then((res) => {
    time.value = Date.now()
    if (res?.data) {
      data.value = res.data || []
    }
  })
}
const getList = () => {
  const obj = {
    teamId: dataScope.value,
    ownerType: !dataScope.value?.length ? '0' : '1',
    moduleType: '1'
  }
  getRecentlyUsedFolderList({
    ...obj
  }).then((res) => {
    if (res.data) {
      recentlyData.value = res.data
    }
  })
}
const add = () => {
  store.openNewFolderModal({
    parentId: '0',
    type: 'add',
    addChild: true,
    teamId: dataScope.value,
    ownerType: !dataScope.value?.length ? '0' : '1',
    notPermissionList: true
  })
}
const selectChange = () => {
  getFolderList()
  getList()
}
watch(
  () => attrs.open,
  (val) => {
    confirmLoading.value = false
    if (val) {
      select.value = []
      if (localCache.getCache('teamMessage').ownerType == 1) {
        dataScope.value = local.get('teamMessage')?.id
      } else {
        dataScope.value = ''
      }

      searchValue.value = ''
      dataScopeList.value = [
        {
          label: '个人空间',
          value: ''
        }
      ]
      onSearch()
      getFolderList()
      getList()
      queryTeam({
        userId: localCache.getCache('USER').id
      }).then((res) => {
        if (res.data) {
          dataScopeList.value.push(...res.data.map((i) => ({ label: i.name, value: i.id, ...i })))
        }
      })
    }
  }
)
eventsBus.on('newFolder', () => {
  getFolderList()
})
</script>

<style lang="less" scoped>
.scroll {
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
}
.count {
  width: 40px;
  margin-left: 10px;
  display: block;
  text-align: right;
}
.menu {
  width: 60px;
  margin-left: 10px;
  display: none;
  text-align: right;
  cursor: pointer;
}
.bg-color {
  background-color: #f0f4ff;
}
.item:hover {
  .count {
    display: none;
  }
  .menu {
    display: block;
  }
}
</style>
